module.exports = __webpack_public_path__ + "static/img/07shangxin.53a30472.gif";